import Link from 'next/link';
import { User, MapPin, BookOpen, MessageSquare, Scroll, MessageCircle, Sparkles, AudioLines, FlaskConical } from 'lucide-react';

interface NavSidebarProps {
  activePath: string;
  children?: React.ReactNode;
}

const navItems = [
  { href: '/',            label: 'Characters',     icon: User,          oracle: false },
  { href: '/locations',   label: 'Locations',      icon: MapPin,        oracle: false },
  { href: '/lore',        label: 'World Lore',     icon: BookOpen,      oracle: false },
  { href: '/chat',        label: 'Ask the Oracle', icon: MessageSquare, oracle: true  },
  { href: '/storyboards', label: 'Storyboards',    icon: Scroll,        oracle: false },
  { href: '/voice-studio',      label: 'Voice Studio',      icon: AudioLines,    oracle: false },
  { href: '/testing-grounds',   label: 'Testing Grounds',   icon: FlaskConical,  oracle: false },
  { href: '/feedback',    label: 'Feedback',       icon: MessageCircle, oracle: false },
  { href: '/updates',     label: "What's New",     icon: Sparkles,      oracle: false },
];

export default function NavSidebar({ activePath, children }: NavSidebarProps) {
  return (
    <aside className="w-64 bg-slate-900 border-r border-slate-800 p-6 flex flex-col gap-6 shrink-0">
      <h1 className="text-2xl font-bold text-purple-400 tracking-wider font-serif uppercase">The Sentinels</h1>

      <nav className="flex flex-col gap-2">
        {navItems.map(({ href, label, icon: Icon, oracle }) => {
          const isActive = activePath === href;
          return (
            <Link
              key={href}
              href={href}
              className={`flex items-center gap-3 p-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-slate-800 text-purple-300'
                  : 'hover:bg-slate-800 text-slate-400'
              } ${oracle ? 'border border-purple-500/20' : ''}`}
            >
              <Icon size={20} /> {label}
            </Link>
          );
        })}
      </nav>

      {children}
    </aside>
  );
}
